import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import AdminLayout from './components/Admin/AdminLayout';
import Admin from './components/Admin/Admin';
import Subscriptions from './components/Admin/Subscriptions';
import PrivateRoute from './components/PrivateRoute';
import AuthProvider from './context/AuthProvider';
import CreateInvoice from './components/Admin/CreateInvoice';
import Markups from './components/Admin/Markups';

const App = () => {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route element={<PrivateRoute />}>
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<Navigate to="/admin/settings" replace />} />
                            <Route path="settings" element={<Admin />} />
                            <Route path="subscriptions" element={<Subscriptions />} />
                            <Route path="create-invoice" element={<CreateInvoice />} />
                            <Route path="markups" element={<Markups />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
};

export default App;